






























































































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { CourseLecture as ICourseLecture } from "@/api/models/course-lecture";
import { Tree as TreeSort, TreeItem } from "@/plugins/tree";
import { Course as ICourse } from "@/api/models/course";
import Modal from "@/components/form/Modal.vue";
import api from "@/getinfo-api";
import { Draggable, Tree } from "he-tree-vue";
import { CourseLectureProgress as ICourseLectureProgress } from "@/api/models/course-lecture-progress";
import { CourseLectureEdit as ICourseLectureEdit } from "@/api/models/course-lecture-edit";
import { isRoot, getCurrentUserId } from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, Tree: Tree.mixPlugins([Draggable]), Modal }
})
export default class CourseLectureTree extends Vue {
  @Prop({ default: false }) isListUpdate?: boolean;
  @Prop() courseLecture!: Array<ICourseLecture>;
  @Prop() course!: ICourse;
  @Prop() lecturesProgress!: Array<ICourseLectureProgress>;
  courseLecturesTree: Array<TreeItem<ICourseLecture>> = [];
  editTree: boolean = false;
  isLoading: boolean = false;

  get userCanEditCourse() {
    return this.root || this.companyCourseOwner || this.courseOwner;
  }

  get root() {
    return isRoot();
  }

  get companyCourseOwner() {
    return this.userId === this.course?.company?.owner?.id;
  }

  get userId() {
    return getCurrentUserId();
  }

  get courseOwner() {
    return this.userId === this.course?.owner?.id;
  }

  cancel() {
    this.editTree = false;
    this.initTree();
  }

  formattedPath(path: Array<number>) {
    let formatted: Array<number> | string = [];
    if (path) {
      formatted = path
        .map((value: number) => {
          return value + 1;
        })
        .join(".");
    }
    return formatted;
  }

  getCheckActive(lectureTitle: string) {
    let lectureProgress = this.lecturesProgress?.filter(
      lecture => lecture.title === lectureTitle
    );

    let progressEntity;
    if (lectureProgress) progressEntity = lectureProgress[0];

    return !progressEntity?.readAt ? "" : "fas fa-check";
  }

  initTree() {
    this.isLoading = true;
    const options = this.courseLecture.map(l => {
      return {
        id: l.id,
        parentId: l.parentId || null,
        entity: l
      };
    });

    const tree = new TreeSort(options);

    this.courseLecturesTree = tree.getTreeItems();
    this.isLoading = false;
  }

  deleteCourseLecture(item: ICourseLecture) {
    this.$emit("deleteItem", item);
  }

  editLecturesTree() {
    this.isLoading = true;
    let _editLecturesTree = (list: Array<TreeItem<ICourseLecture>>) => {
      let childSort = 1;
      for (let parent of list) {
        if (parent.children && parent.children.length) {
          let parentId = parent.node.id;
          for (let child of parent.children) {
            let childId = child.node.id;
            let editInfo: Array<ICourseLectureEdit> = [
              {
                id: childId,
                parentId: parentId,
                sort: childSort++
              }
            ];
            api.CourseLectureApi.edit(this.course.id, editInfo);
          }
          _editLecturesTree(parent.children);
        }
      }
    };
    _editLecturesTree(this.courseLecturesTree);

    let firstLevel = async () => {
      let parentSort = 1;
      let firstLevelLecture: Array<ICourseLectureEdit> = [];

      await Promise.allSettled(
        this.courseLecturesTree.map(async el => {
          const parentNull: ICourseLectureEdit = {
            id: el.node.id,
            sort: parentSort++,
            parentNull: true
          };
          firstLevelLecture.push(parentNull);
          await api.CourseLectureApi.edit(this.course.id, firstLevelLecture);
        })
      );
    };

    firstLevel().then(() => {
      this.editTree = false;
      // setTimeout(() => {
      //   this.$emit("update");
      // }, 2000);
      this.$emit("update");
      this.isLoading = false;
      this.$bvToast.toast(
        `${this.$tc(this.$translate.ChangesHaveBeenSuccessfullySaved)}`,
        {
          variant: "success",
          title: `${this.$tc(this.$translate.Success)}`
        }
      );
    });
  }

  @Watch("courseLecture")
  upd() {
    this.initTree();
  }

  created() {
    this.initTree();
  }
}
